import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import * as LoginMethodActions from '../actions/loginmethod.actions';

@Injectable()
export class LoginMethodEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private appGlobalService = inject(AppGlobalService);

  getSidBasedLoginMethod$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginMethodActions.getLoginMethod),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + this.appGlobalService.get('appId');

          return this.baseService[apiConstants?.method](apiConstants).subscribe((sidLoginMethodData: any) => {
            this.store.dispatch(
              LoginMethodActions.setLoginMethod({
                loginMethodData: sidLoginMethodData
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
  saveLoginMethod$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginMethodActions.sentLoginMethod),
        map((action: any) => {
          const loginMethodApi = { ...action };
          return this.baseService[action.apiConstants?.method](
            loginMethodApi.apiConstants,
            loginMethodApi.saveLoginMethodData
          ).subscribe((sidLoginMethodData: any) => {
            this.store.dispatch(
              LoginMethodActions.saveLoginMethod({
                loginMethodData: sidLoginMethodData
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
  updateLoginMethod$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LoginMethodActions.sentUpdateLoginMethod),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.sid;

          return this.baseService[apiConstants?.method](apiConstants).subscribe((sidLoginMethodData: any) => {
            this.store.dispatch(
              LoginMethodActions.updateLoginMethod({
                loginMethodData: sidLoginMethodData
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
}
